export default __webpack_public_path__ + "static/media/DefaultIcon.0dbd435f.svg";